<select class="form-select mw-50" id="currencySelect" [formControl]="currency" aria-label="Select currency"
    (change)="onSelectionChange($event)" (blur)="onBlur()">

    @for (c of currenciesList(); track c.currencyId) {
        <option [value]="c.currencyId">{{c.code}} - {{c.name | titlecase}}</option>
    }
</select>
